// frontend/src/components/PartidaItem.jsx
import React, { useState } from 'react';
import { toast } from 'react-toastify';
import presupuestosService from '../services/presupuestosService';
import RecursoItem from './RecursoItem';
import CrearRecursoModal from './CrearRecursoModal';
import CrearOrdenCompraMultipleModal from './CrearOrdenCompraMultipleModal';
import './PartidaItem.css';

const PartidaItem = ({ partida, isExpanded, onToggle, onUpdate, isAprobado = false, presupuestoId, presupuestoStatus, onAbrirOrdenCompra, area }) => {
  const [showCrearRecursoModal, setShowCrearRecursoModal] = useState(false);
  const [expandedRecursos, setExpandedRecursos] = useState({});
  const [modoSeleccion, setModoSeleccion] = useState(false);
  const [recursosSeleccionados, setRecursosSeleccionados] = useState([]);
  const [showCrearOCMultipleModal, setShowCrearOCMultipleModal] = useState(false);

  const handleAddRecurso = async (recursoData) => {
    try {
      // Si es un recurso nuevo, crearlo
      if (!recursoData.id && recursoData.nombre_recurso) {
        await presupuestosService.createRecurso({
          partida: partida.id,
          nombre_recurso: recursoData.nombre_recurso,
          descripcion: recursoData.descripcion || '',
          cantidad: recursoData.cantidad || 0,
          valor_unitario: recursoData.valor_unitario || 0,
          unidad: recursoData.unidad || 'unidad',
          proveedor: recursoData.proveedor || null,
          status: 'activo'
        });
        toast.success('Recurso creado exitosamente');
      }
      setShowCrearRecursoModal(false);
      onUpdate();
    } catch (error) {
      console.error('Error al agregar recurso:', error);
      toast.error('Error al agregar recurso');
    }
  };

  const toggleRecurso = (recursoId) => {
    setExpandedRecursos(prev => ({
      ...prev,
      [recursoId]: !prev[recursoId]
    }));
  };

  const handleToggleModoSeleccion = () => {
    setModoSeleccion(!modoSeleccion);
    if (modoSeleccion) {
      // Si estamos desactivando el modo selección, limpiar selecciones
      setRecursosSeleccionados([]);
    }
  };

  const handleToggleRecursoSeleccion = (recurso) => {
    setRecursosSeleccionados(prev => {
      const isSelected = prev.find(r => r.id === recurso.id);
      if (isSelected) {
        return prev.filter(r => r.id !== recurso.id);
      } else {
        return [...prev, recurso];
      }
    });
  };

  const handleCrearOrdenCompraMultiple = () => {
    if (recursosSeleccionados.length === 0) {
      toast.error('Selecciona al menos un item');
      return;
    }
    setShowCrearOCMultipleModal(true);
  };

  const handleOCCreated = () => {
    setRecursosSeleccionados([]);
    setModoSeleccion(false);
    setShowCrearOCMultipleModal(false);
    onUpdate();
  };

  return (
    <div className="partida-item">
      <div className="partida-header">
        <button
          className="expand-btn"
          onClick={onToggle}
          title={isExpanded ? 'Contraer' : 'Expandir'}
        >
          {isExpanded ? '▼' : '▶'}
        </button>

        <div className="partida-info">
          <h4>💼 {partida.nombre_partida}</h4>
          <div className="partida-details">
            <span className="detail">Cant: {partida.cantidad}</span>
            <span className="detail">Unitario: ${partida.valor_unitario.toLocaleString('es-CL')}</span>
            <span className="detail-total">Total: ${partida.total_partida.toLocaleString('es-CL')}</span>
          </div>
        </div>

        <div className="partida-actions">
          {isExpanded && !isAprobado && (
            <button
              className="btn btn-small btn-add"
              onClick={() => setShowCrearRecursoModal(true)}
              title="Agregar recurso"
            >
              ➕
            </button>
          )}

          {isExpanded && presupuestoStatus === 'aprobado' && partida.recursos && partida.recursos.length > 0 && (
            <div className="partida-oc-actions">
              <button
                className={`btn btn-small ${modoSeleccion ? 'btn-secondary' : 'btn-primary'}`}
                onClick={handleToggleModoSeleccion}
                title={modoSeleccion ? 'Cancelar selección' : 'Seleccionar items'}
              >
                {modoSeleccion ? '✕ Cancelar' : '☑ Seleccionar items'}
              </button>

              {modoSeleccion && recursosSeleccionados.length > 0 && (
                <button
                  className="btn btn-small btn-success"
                  onClick={handleCrearOrdenCompraMultiple}
                  title={`Crear orden de compra (${recursosSeleccionados.length} items seleccionados)`}
                >
                  ➕ Orden Compra ({recursosSeleccionados.length})
                </button>
              )}
            </div>
          )}
        </div>
      </div>

      {isExpanded && (
        <div className="partida-content">
          <div className="recursos-list">
            {partida.recursos && partida.recursos.length > 0 ? (
              partida.recursos.map(recurso => (
                <RecursoItem
                  key={recurso.id}
                  recurso={recurso}
                  onUpdate={onUpdate}
                  isAprobado={isAprobado}
                  presupuestoId={presupuestoId}
                  presupuestoStatus={presupuestoStatus}
                  onAbrirOrdenCompra={onAbrirOrdenCompra}
                  partida={partida}
                  area={area}
                  modoSeleccion={modoSeleccion}
                  isSelected={recursosSeleccionados.some(r => r.id === recurso.id)}
                  onToggleSeleccion={() => handleToggleRecursoSeleccion(recurso)}
                />
              ))
            ) : (
              <div className="empty-recursos">
                <p>📭 No hay recursos en esta partida</p>
                {!isAprobado && (
                  <button
                    className="btn btn-small btn-primary"
                    onClick={() => setShowCrearRecursoModal(true)}
                  >
                    Agregar Recurso
                  </button>
                )}
                {isAprobado && (
                  <p style={{ color: '#ef4444', fontSize: '0.85rem', marginTop: '0.5rem' }}>
                    ⚠️ No puedes agregar recursos a un presupuesto aprobado
                  </p>
                )}
              </div>
            )}
          </div>
        </div>
      )}

      {showCrearRecursoModal && (
        <CrearRecursoModal
          partidaId={partida.id}
          onClose={() => setShowCrearRecursoModal(false)}
          onRecursoAdded={handleAddRecurso}
        />
      )}

      {showCrearOCMultipleModal && (
        <CrearOrdenCompraMultipleModal
          recursosSeleccionados={recursosSeleccionados}
          presupuestoId={presupuestoId}
          partida={partida}
          area={area}
          onClose={() => setShowCrearOCMultipleModal(false)}
          onCreated={handleOCCreated}
        />
      )}
    </div>
  );
};

export default PartidaItem;
